import React from 'react';
import { t } from '../../services/i18nService';
import viewReadyTracker from '../../services/ViewReadyTracker';
import styles from './invalidTabToken.scss';

class InvalidTabToken extends React.PureComponent {
    componentDidMount() {
        viewReadyTracker.getReporter()(true);
    }

    createCaptionHtml = () => {
        return { __html: t('alert.invalidTabToken.message') };
    };

    render() {
        return (
            <div className={styles.invalidTabToken} role="main">
                <i className="fa fa-copy fa-2x" />
                <span dangerouslySetInnerHTML={this.createCaptionHtml()} />
            </div>
        );
    }
}

export default InvalidTabToken;
